import ngReduxProvider from './components/ngRedux';


const angular = require('angular');

export default angular.module('ngRedux', [])
  .provider('$ngRedux', ngReduxProvider)
  .name;



// WEBPACK FOOTER //
// ./src/js/_libs/ng-redux/index.js